export const formatIdentifier = (value) => {
    if (value == null || value === "") {
        return "";
    }

    if (typeof value === "number" && Number.isFinite(value)) {
        return BigInt(Math.trunc(value)).toString();
    }

    const str = String(value).trim();
    if (/^[+-]?\d*\.?\d+[eE][+-]?\d+$/.test(str)) {
        const num = Number(str);
        if (Number.isFinite(num)) {
            return BigInt(Math.trunc(num)).toString();
        }
    }

    if (/^\d+\.0+$/.test(str)) {
        return str.split(".")[0];
    }

    return str;
};

export const emptyToNull = (value) => {
    if (value == null) {
        return null;
    }
    if (typeof value === "string" && value.trim() === "") {
        return null;
    }
    return typeof value === "string" ? value.trim() : value;
};

export const normalizeOptionalNumericField = (value) => {
    const formatted = formatIdentifier(value);
    return formatted ? formatted : null;
};
